module.exports = __webpack_public_path__ + "media/images/static/top/urban/MV首都圏-1161fdbba94f969580c88f0103502a0c.png";